export default "__VITE_ASSET__DfDDKSak__"